import React from 'react';
import { Form, DatePicker as AntDatePicker } from 'antd';
import { useField } from 'formik';
import moment from 'moment';
import { APP_DATE_INPUT_FORMAT } from '../../../config';

function DatePicker({
  name,
  inputReadOnly = false,
  showTime = false,
  showTimeFormat,
  ...rest
}) {
  const [field, meta, helpers] = useField(name);
  const config = { ...field, ...rest };
  if (meta && meta.touched && meta.error) {
    config.error = true;
    config.helperText = meta.error;
  }

  const handleChangeDate = (value) => {
    helpers.setValue(
      value ? (showTime ? value : value.format(APP_DATE_INPUT_FORMAT)) : ''
    );
    helpers.setError('');
    helpers.setTouched(false);
  };

  const pickerProps = {
    style: {
      width: '100%',
    },
    format: APP_DATE_INPUT_FORMAT,
    onChange: handleChangeDate,
    ...rest,
  };

  if (showTime) {
    pickerProps.format += ` ${showTimeFormat}`;
  }

  if (field?.value) {
    pickerProps.value = moment(field.value, APP_DATE_INPUT_FORMAT);
  }

  return (
    <Form.Item
      label={rest?.label}
      name={name}
      help={meta?.error && meta?.error && meta?.touched ? meta.error : ''}
      validateStatus={config?.error ? 'error' : 'success'}
    >
      <div>
        <AntDatePicker
          {...pickerProps}
          picker="date"
          showTime={showTime}
          inputReadOnly={inputReadOnly}
        />
      </div>
    </Form.Item>
  );
}

export default DatePicker;
